/* eslint-disable */
import { useEffect, useState } from 'react';
import UserPersona from './UserPersona';
import { API } from 'helper/requests';
import { LOGIN_RESP_MOCK } from 'client/__mock__/appmock';
import { PAGE_ID } from 'constants/tracker';
import { trackPageInfo, trackLoggedInUserInfo } from 'helper/analytics';
import APIURLPATH from 'constants/apiconstants';
import { getData } from 'service/getData.service';
import { deepClone } from 'helper/helper';
import { routeToApps } from 'helper/utils';
import { BASICUSERS, CHARTER, BASIC, STUDENT_CODE, PORTAL_CONTEXT, SHOW_REPORT_EXPIREING_ALERT } from 'constants/constant';

const callUserContext = () => {
	const [data, setdata] = useState(null);
	const [loading, setloading] = useState(true);
	const [error, seterror] = useState(false);

	async function setResponseData(_response) {
		let _data = {};
		
		const { user_type, blackout, sbus, tenant, user_preferences, persona_access_codes, login_id, first_name, last_name, email_address, products } = _response;
		const response = {
			result: {
				userType: user_type,
				catManUser: persona_access_codes?.includes('2000'), 
				blackOut: blackout, 
				sbu: sbus, 
				companyType: tenant.type,
				companyName: tenant.name,
				locale: user_preferences.language_code,
				timezone: user_preferences.locale.timezone,
				loginId: login_id,
				firstName: first_name,
				lastName: last_name, 
				email: email_address,
				personaAccessCodes :persona_access_codes,
				products: products,
				..._response
			}
		}

		const checkAccess = val => [4,13].includes(val.product_id);
		if(!products.some(checkAccess)) {
			routeToApps();
		}
		const userDetails = UserPersona(response);
		const { companyName, loginId } = userDetails?.result;
		const request = { companyName, loginId };
		const URL = APIURLPATH.ITEM_SHARE;
		const res = await getData(URL, request);
		if (res.statusCode >= 400) {
			_data['itemShareAccepted'] = false;
		} else {
			_data['itemShareAccepted'] = res.json.itemShareAccepted;
		}
		_data['userDetails'] = userDetails;
		const basicUser = BASICUSERS.includes(userDetails?.result?.companyType) ? true : false;
		if (basicUser) {
			_data['customerType'] = BASIC;
		} else {
			_data['customerType'] = CHARTER;
		}
		const personaAccessCodes = userDetails?.result?.personaAccessCodes;
		_data['isStudent'] = personaAccessCodes?.includes(STUDENT_CODE),
		setdata(_data);
		setloading(false);
		localStorage.setItem(PORTAL_CONTEXT, userDetails);
		localStorage.setItem(SHOW_REPORT_EXPIREING_ALERT, true);
		trackLoggedInUserInfo(userDetails.result);
	}

	useEffect(async () => {
		trackPageInfo(PAGE_ID['APP_LAUNCH']);
		if (process.env.NODE_ENV === 'development') {
			setResponseData(LOGIN_RESP_MOCK.result);
		} else {
			try {
				const URL = APIURLPATH.PORTAL_USER_INFO;
				const res = await fetch(URL, {
					headers: API.DEFAULT_HEADER
				});
				const response = await res.json();
				if ([API.RESPONSE.UNAUTHORIZED, API.RESPONSE.REDIRECTSTATUS].includes(res.status)) {
					seterror(true);
				} else {
					setResponseData(response);
				}
			} catch (error) {
				seterror(true);
				setloading(false);
			}
		}
	}, []);

	const updateUserPersona = (userPersona) => {
		const _d = deepClone(data);
		_d['userDetails'].result['userPersona'] = userPersona;
		setdata(_d);
	};

	const updateItemShareAccepted = (isAccepted) => {
		const _d = deepClone(data);
		_d['itemShareAccepted'] = isAccepted;
		setdata(_d);
	};

	return { data, loading, error, updateUserPersona, updateItemShareAccepted };
};

export default callUserContext;
